import { cn } from '@/lib/utils';
import { Package, Shield, Truck } from 'lucide-react';
import { ShipmentStatusCardProps, ShipmentStatusCardType } from './types';

const cardConfig: Record<ShipmentStatusCardType, {
  description: string;
  icon: typeof Truck;
  iconClassName: string;
  title: string;
}> = {
  atWarehouse: {
    description: 'Готовы',
    icon: Package,
    iconClassName: 'text-success',
    title: 'На складе'
  },
  customs: {
    description: 'Ожидают',
    icon: Shield,
    iconClassName: 'text-warning',
    title: 'Таможня'
  },
  inTransit: {
    description: 'Активны',
    icon: Truck,
    iconClassName: 'text-accent',
    title: 'В пути'
  }
};

const ShipmentStatusCard = (props: ShipmentStatusCardProps) => {
  const {
    count,
    onClick,
    type
  } = props;

  const {
    description,
    icon: Icon,
    iconClassName,
    title
  } = cardConfig[type];

  return (
    <button
      className={cn(
        'group flex min-w-0 flex-1 flex-col gap-2 px-4 py-3',
        'text-left',
        'rounded-2xl border border-border-strong bg-surface',
        'transition-colors hover:bg-accent-soft active:bg-accent-soft'
      )}
      onClick={onClick}
      type="button"
    >
      <span className="flex w-full min-w-0 items-center gap-2">
        <Icon className={`size-5 shrink-0 ${iconClassName}`} strokeWidth={1.75} />
        <span className="truncate font-sans text-xs leading-4 text-foreground">{title}</span>
      </span>
      <span className="flex w-full flex-col gap-1">
        <span
          className={cn(
            'font-sans text-lg font-semibold leading-6',
            'transition-colors group-hover:text-foreground group-active:text-foreground',
            count > 0 ? 'text-foreground' : 'text-muted-foreground'
          )}
        >
          {count}
        </span>
        <span
          className={cn(
            'w-full border-t border-border-strong pt-1',
            'font-sans text-[10px] leading-[14px] tracking-[0.2px] text-muted-foreground uppercase'
          )}
        >
          {description}
        </span>
      </span>
    </button>
  );
};

export default ShipmentStatusCard;